// Interaction metrics
export const SPELLING_METRIC_ENABLED = false;
export const GRAMMAR_METRIC_ENABLED = false;
export const EXPERIENCE_SCORE_METRIC_ENABLED = true;

// Filters
export const VECTOR_SEARCH_ENABLED = false;
export const WRITING_ISSUES_FILTER_ENABLED = false;

// Charts
export const AGENTS_STATE_CHART_ENABLED = true;

// Table columns
export const INTERACTIONS_COUNTS_BETWEEN_STATES_ENABLED = false;

// Screens
export const SPELLING_EXEMPTIONS_SCREEN_ENABLED = true;
export const TAG_COMPARISON_SCREEN_ENABLED = true;
export const MANAGE_AGENT_TAGS_ENABLED = true;

// Menu actions
export const REINVITE_USER_ACTION_ENABLED = true;
export const REMOVE_USER_ACTION_ENABLED = true;

export const EDIT_INTERACTION_TAGS_ENABLED = true;
export const ADD_TAGS_TO_INTERACTION_MESSAGE_ENABLED = false;

export const FILTER_TAGS_ENABLED = true;

// Open search
export const OPEN_SEARCH_PHRASE_ENABLED = true;

// Customizable charts
export const CUSTOMIZABLE_EXPLORE_CHARTS = true;
